var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpRight = function SvgUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98934 5.0475C9.20087 4.83597 9.20087 4.493 8.98934 4.28147C8.77781 4.06993 8.43484 4.06993 8.22331 4.28147L3.62711 8.87766C3.41558 9.0892 3.41558 9.43216 3.62711 9.6437C3.83865 9.85523 4.18161 9.85523 4.39315 9.6437L8.98934 5.0475Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39335 4.8229C4.0942 4.8229 3.85168 4.58038 3.85168 4.28123C3.85168 3.98208 4.0942 3.73956 4.39335 3.73956H8.98955C9.27955 3.73956 9.5181 3.96797 9.5307 4.2577L9.72221 8.66239C9.7352 8.96126 9.50345 9.21408 9.20458 9.22707C8.90571 9.24007 8.65289 9.00832 8.6399 8.70945L8.47092 4.8229H4.39335Z",
    fill: "currentcolor"
  })));
};
export default SvgUpRight;